import LoadingSpinner from '../../chat_screen_loader';

export function showSpinner(spinnerFlag) {
    return (
      spinnerFlag && spinnerFlag === true ? <LoadingSpinner /> : null
    )
  }